module.exports = __webpack_public_path__ + "static/media/Paoline_desktop_article_7.f422ae39.jpg";